import * as React from 'react'
import { GroupDetail } from 'capacity/hooks/useTimeSlotGroupDetails'
import { CapacityRow, LinesRow, MessageRow, PendingRow } from './rows'
import { TimeSlotGroupCard } from './timeSlotGroupCard'
import { PartState } from '../model/sectionState'

interface SectionPartProps {
    state: PartState
    accountSlug: string
    details?: Record<string, GroupDetail>
}

// Draws one part of the Capacity block from its state; the decisions live in sectionState.ts.
export function SectionPart({ state, accountSlug, details = {} }: SectionPartProps) {
    switch (state.kind) {
        case 'pending':
            return <PendingRow />
        case 'message':
            return <MessageRow text={state.text} />
        case 'lines':
            return <LinesRow lines={state.lines} linkTo={state.linkTo} linkLabel={state.linkLabel} />
        case 'rows':
            return (
                <>
                    {state.rows.map((row) => (
                        <CapacityRow
                            key={row.key}
                            href={row.href}
                            name={row.name}
                            detail={row.detail}
                            pending={row.pending}
                        />
                    ))}
                </>
            )
        case 'blocks':
            return (
                <div className="capacity-section-blocks">
                    {state.lead && <p className="capacity-section-lead">{state.lead}</p>}
                    {state.blocks.map((block) => (
                        <div className="capacity-section-block" key={block.label}>
                            <div className="capacity-section-block-label">{block.label}</div>
                            {block.groups.map((group) => (
                                <TimeSlotGroupCard
                                    key={group.id}
                                    accountSlug={accountSlug}
                                    group={group}
                                    detail={details[group.id]}
                                />
                            ))}
                        </div>
                    ))}
                </div>
            )
        default:
            return null
    }
}
